import { render, staticRenderFns } from "./HeaderButton.vue?vue&type=template&id=ffa33342&scoped=true&"
import script from "./HeaderButton.vue?vue&type=script&lang=js&"
export * from "./HeaderButton.vue?vue&type=script&lang=js&"
import style0 from "./HeaderButton.vue?vue&type=style&index=0&id=ffa33342&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa33342",
  null
  
)

export default component.exports